import { Controller } from "@hotwired/stimulus"

// Fallback v2 inline: quando o v3 dá score baixo, o servidor responde com um
// turbo_stream que substitui o slot (#recaptcha-fallback-slot) em estado
// "revealed". Aqui renderizamos o checkbox v2 (grecaptcha.render, com a sitekey
// v2 explícita sobre o mesmo api.js carregado com render=<v3>), e ao resolver
// gravamos o token v2 + a flag recaptcha_v2_fallback no form — sem recarregar a
// página, preservando os dados do cartão já preenchidos.
export default class extends Controller {
  static targets = ["widget"]
  static values = { siteKey: String, revealed: Boolean }

  connect() {
    if (this.revealedValue) this.renderWidget()
  }

  renderWidget() {
    if (this.rendered || !this.hasWidgetTarget) return
    if (typeof grecaptcha === "undefined" || !grecaptcha.render) return
    this.rendered = true
    grecaptcha.render(this.widgetTarget, {
      sitekey: this.siteKeyValue,
      callback: (token) => this.onSolved(token),
      "expired-callback": () => this.onExpired()
    })
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  onSolved(token) {
    const form = this.element.closest("form")
    if (!form) return

    let resp = form.querySelector('input[name="g-recaptcha-response"]')
    if (!resp) {
      resp = document.createElement("input")
      resp.type = "hidden"
      resp.name = "g-recaptcha-response"
      form.appendChild(resp)
    }
    resp.value = token

    if (!form.querySelector('input[name="recaptcha_v2_fallback"]')) {
      const flag = document.createElement("input")
      flag.type = "hidden"
      flag.name = "recaptcha_v2_fallback"
      flag.value = "1"
      form.appendChild(flag)
    }
  }

  onExpired() {
    const resp = this.element.closest("form")?.querySelector('input[name="g-recaptcha-response"]')
    if (resp) resp.value = ""
  }
}
